import type { FC } from 'react';
import { LambdaExpressionsWrapper } from './LambdaExpressions.styled';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';

interface LambdaExpressionsProps { }

const LambdaExpressions: FC<LambdaExpressionsProps> = () => (
   <LambdaExpressionsWrapper>
      <header className="entry-header ">
         <h1 className="entry-title" itemProp="headline">Lambda Expressions</h1>
      </header>
      <br/>
      <div className="entry-content clear" itemProp="text" style={{ height: 'auto !important' }}>
         <p className="text-align-justify">Lambda expression is a new and important feature of Java which was made available in Java SE 8. It basically provides a way to represent one method interface using an expression. In addition, it helps to iterate, filter, and extract data from a collection.</p>
         <ul className="text-align-justify">
            <li>The Lambda expression helps to provide the implementation of an interface that has a functional interface(An interface with single abstract method). </li>
            <li>In addition, the body of a lambda expression can contain zero, one or more statements.</li>
            <li>However, there is no need to declare the type of a parameter. The compiler can inference the same from the value of the parameter.</li>
            <li>If a single statement is present, curly brackets are not mandatory and the return type of the anonymous function is the same as that of the body expression.</li>
            <li>If there is more than one statement present, then these must be enclosed in curly brackets (a code block). In addition to this, the return type of the anonymous function is the same as the type of the value that is returned within the code block, or void if nothing is returned.</li>
         </ul>
         <p className="text-align-justify"><strong>Syntax </strong>: </p>
         <SyntaxHighlighter language="" style={dracula} showLineNumbers={true}>
            {
               'lambda operator -> body or(Argument list) arrowToken {\n'+
               '  body\n'+
               '}\n'+
               'where lambda operator can be:\n'+
               '\n'+
               'For Zero parameter – ()\n'+
               'System.out.println("Zero param lambda");\n'+
               '\n'+
               'For One parameter – (p)\n'+
               'System.out.println("One param lambda: " + p);\n'+
               '\n'+
               'For Multiple parameters – (p1, p2)\n'+
               'System.out.println("Multiple param: " + p1 + ", " + p2);'
            }
         </SyntaxHighlighter>
         <br/>
         <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
            {
               '@FunctionalInterface\n'+
               'interface Drawable {\n'+
               '  public void draw();\n'+
               '}\n'+
               '\n'+
               '@FunctionalInterface\n'+
               'interface Drawable2 {\n'+
               '  public void draw2(int dimension);\n'+
               '}\n'+
               '\n'+
               '@FunctionalInterface\n'+
               'interface Drawable3 {\n'+
               '  public void draw3(int length, int width);\n'+
               '}\n'+
               '\n'+
               'public class LambdaExpressionDemo {\n'+
               '  public static void main(String args[]) {\n'+
               '    int size = 10;\n'+
               '\n'+
               '    //No parameter without return statement\n'+
               '    Drawable d1 = () -> {\n'+
               '      System.out.println("Drawable " + size);\n'+
               '    };\n'+
               '\n'+
               '    //No parameter with return statement\n'+
               '    Drawable d2 = () -> {\n'+
               '      return size;\n'+
               '    };\n'+
               '\n'+
               '    //Single parameter with return statement\n'+
               '    Drawable d3 = (dimension) -> {\n'+
               '      return dimension;\n'+
               '    };\n'+
               '\n'+
               '    //Multiple parameter without return statement\n'+
               '    Drawable d4 = (a, b) -> (a + b);\n'+
               '    d1.draw();\n'+
               '    d2.draw();\n'+
               '    d3.draw2(5);\n'+
               '    d4.draw3(1, 8);\n'+
               '\n'+
               '    //Multiple parameter with return statement\n'+
               '    Drawable3 d5 = (int a, int b) -> {\n'+
               '      return (a + b);\n'+
               '    };\n'+
               '\n'+
               '    //LambdaExpression to filter stream\n'+
               '    List <Product> list = new ArrayList <Product> ();\n'+
               '    list.add(new Product(1, "Samsung A5", 17000 f));\n'+
               '    Stream <Product> filtered_data = list.stream().filter(\n'+
               '      product -> product.price> 20000\n'+
               '    );\n'+
               '\n'+
               '    //LambdaExpression on foreach loop\n'+
               '    filtered_data.forEach(\n'+
               '      product -> System.out.println(product.price)\n'+
               '    );\n'+
               '  }\n'+
               '}'
            }
         </SyntaxHighlighter>
      </div>
   </LambdaExpressionsWrapper>
);

export default LambdaExpressions;
